export default "__VITE_ASSET__B2sk_$Bo__"